import React from "react";
import FaClose from "react-icons/lib/fa/close";


export default class CloseButton extends React.Component {

  handleCloseButton = () => {
    this.props.handleCloseButton();
  }

  render() {
    return (
      <div className="close-button">
        <button onClick={this.props.handleCloseButton}>
          <FaClose/>
        </button>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/CloseButton.js